import { useAnonymousSession } from './session';

export const useIsSiteUser = () => {
	const { user } = useAnonymousSession();
	return Boolean(user?.siteUserId);
};
